import { render, staticRenderFns } from "./collection-item-minimal.vue?vue&type=template&id=01c4a08e&"
import script from "./collection-item-minimal.vue?vue&type=script&lang=js&"
export * from "./collection-item-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports